module.exports = __webpack_public_path__ + "static/media/CSharp.75c9e79c.png";